import { NgModule } from '@angular/core';

//DevExpress built-in stuff
import { DevExtremeModule } from 'devextreme-angular';




@NgModule({
    imports:
        [
            DevExtremeModule
        ],
 
    exports:
        [
            DevExtremeModule
        ]
    
})
export class M4UDevExpressModule
{

}